import { ISelect } from '../types/shared';

export const formatParams = <T extends ISelect>(list: T[]): ISelect[] =>
    JSON.parse(JSON.stringify(list))?.map((item: T) => ({
        id: item.id,
        name: item.name,
    }));
